export default "__VITE_ASSET__DpDn2Q2G__"